var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pt-3 bg-white" },
    [
      _c("pc-my-project-header", {
        attrs: {
          projectDetails: _vm.projectDetails,
          onClickHandler: _vm.handleCreateNewProject,
          projectId: _vm.trayId,
          userRole: _vm.userRole
        },
        on: { editProject: _vm.editProject }
      }),
      _vm._v(" "),
      _c("pc-my-project-hero-banner", {
        attrs: { projectDetails: _vm.projectDetails, userRole: _vm.userRole },
        on: { editProject: _vm.editProject }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "container" }, [
        _c(
          "div",
          { staticClass: "mt-5" },
          [
            _c("pc-my-project-item", {
              attrs: {
                col: 6,
                projectDetails: _vm.projectDetails,
                userRole: _vm.userRole
              },
              on: {
                editContent: function($event) {
                  return _vm.editContent($event)
                },
                editColorImg: function($event) {
                  return _vm.editColorImg($event)
                }
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _vm.userRole
          ? _c("div", { staticClass: "row mt-5 mb-3 text-center" }, [
              _c(
                "div",
                { staticClass: "col-sm-12 mb-5 add-button" },
                [
                  _c("add-item-button", {
                    attrs: {
                      onClickHandler: _vm.handleCreateNewProject,
                      buttonText: _vm.buttonText
                    }
                  })
                ],
                1
              )
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "modal",
        {
          staticClass: "my-project-modal",
          attrs: {
            height: "650",
            name: "project-wizard-content-modal",
            "data-html2canvas-ignore": "true",
            adaptive: true,
            projectId: _vm.trayId,
            scrollable: true
          }
        },
        [
          _c("pc-project-wizard-content-modal", {
            attrs: { projectDetails: _vm.projectDetails },
            on: { closeModal: _vm.closeModal }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            height: "500",
            name: "create-project-modal",
            "data-html2canvas-ignore": "true",
            adaptive: true,
            scrollable: true
          }
        },
        [
          _c("pc-my-project-create-modal", {
            attrs: {
              projectId: _vm.trayId,
              projectDetails: _vm.projectDetails,
              isEdit: _vm.isEdit,
              trayId: _vm.trayId,
              adaptive: true
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            height: "500",
            name: "create-brand-project-modal",
            "data-html2canvas-ignore": "true",
            adaptive: true,
            scrollable: true
          }
        },
        [
          _c("pc-my-project-brand-create-modal", {
            attrs: {
              projectId: _vm.trayId,
              projectDetails: _vm.projectDetails,
              isEdit: _vm.isEdit,
              trayId: _vm.trayId,
              adaptive: true
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            height: "650",
            name: "project-upload-image-modal",
            "data-html2canvas-ignore": "true",
            adaptive: true
          }
        },
        [_c("pc-project-upload-image-modal")],
        1
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            height: "400",
            name: "project-edit-content-item-modal",
            "data-html2canvas-ignore": "true",
            adaptive: true,
            scrollable: true
          }
        },
        [
          _c("pc-my-project-edit-content-item", {
            attrs: {
              projectID: _vm.projectDetails.boardDetails.id,
              productData: _vm.productData
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            height: "500",
            name: "project-edit-colors-feature-img-modal",
            "data-html2canvas-ignore": "true",
            adaptive: true,
            scrollable: true
          }
        },
        [
          _c("pc-my-project-edit-colors-feature-img", {
            attrs: {
              projectDetails: _vm.projectDetails,
              productData: _vm.productData
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            height: "450",
            name: "share-project-modal",
            "data-html2canvas-ignore": "true",
            adaptive: true,
            scrollable: true
          }
        },
        [
          _c("pc-share-project-modal", {
            attrs: {
              projectDetails: _vm.projectDetails,
              productData: _vm.productData,
              userRole: _vm.userRole,
              isAdmin: _vm.isAdminUser,
              userEmail: _vm.userEmail
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }